
//# sourceMappingURL=ICanvasRenderingContext2D.mjs.map
